import styled from 'styled-components';
import { TextLabel } from '../TextLabel';

const StyledContainer = styled.div`
	display: grid;
	grid-template-columns: 300px 1fr;
	transition: opacity 0.3s ease;

	&.tab-enter {
		opacity: 0;
	}

	&.tab-enter-active,
	&.tab-enter-done,
	&.tab-exit {
		opacity: 1;
	}

	&.tab-exit-active {
		opacity: 0;
	}
`;

const StyledLeftContainer = styled.div`
	border-right: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledNotSelectedDialogContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	height: 629px;

	${TextLabel} {
		font-size: 14px;
		color: #ffffff;
		opacity: 0.25;
	}
`;

const StyledLeftContainerTitle = styled.div`
	display: flex;
	align-items: center;
	height: 80px;
	padding-left: 25px;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);

	${TextLabel} {
		font-weight: 500;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledDialogsListContainer = styled.div`
	height: 549px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		display: none;
	}
`;

export {
	StyledContainer,
	StyledLeftContainer,
	StyledLeftContainerTitle,
	StyledDialogsListContainer,
	StyledNotSelectedDialogContainer,
};
